import React, { useState, useEffect } from 'react';
import { Send, CheckCircle } from 'lucide-react';
import { useLanguage } from '../LanguageContext';

export const RSVPForm = () => {
  const { t } = useLanguage();
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    attendance: 'yes',
    numberOfGuests: '1',
    guestNames: [''],
    message: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);

  // Update guest names array when number of guests changes
  useEffect(() => {
    const numGuests = parseInt(formData.numberOfGuests);
    const currentNames = [...formData.guestNames];
    
    if (numGuests > currentNames.length) {
      const newNames = [...currentNames, ...Array(numGuests - currentNames.length).fill('')];
      setFormData(prev => ({ ...prev, guestNames: newNames }));
    } else if (numGuests < currentNames.length) {
      setFormData(prev => ({ ...prev, guestNames: currentNames.slice(0, numGuests) }));
    }
  }, [formData.numberOfGuests]);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [id]: value
    }));
  };

  const handleGuestNameChange = (index, value) => {
    const newGuestNames = [...formData.guestNames];
    newGuestNames[index] = value;
    setFormData(prev => ({
      ...prev,
      guestNames: newGuestNames
    }));
  };

  return (
    <section id="rsvp" className="rsvp-section">
      <div className="container">
        <div className="section-header">
          <Send className="section-icon" />
          <h2 className="section-title">{t('rsvp.title')}</h2>
          <div className="decorative-line-small"></div>
          <p className="section-subtitle">
            {t('rsvp.subtitle')}
          </p>
        </div>

        <div className="rsvp-container" data-aos="fade-up">
          {isSubmitted ? (
            <div className="rsvp-success">
              <CheckCircle size={64} className="success-icon" />
              <h3>{t('rsvp.thankYou')}</h3>
              <p>{t('rsvp.thankYouMessage')}</p>
            </div>
          ) : (
            <form 
              action="https://formsubmit.co/mariage.hatem.nourhene@gmail.com" 
              method="POST"
              className="rsvp-form"
            >
              {/* FormSubmit Configuration */}
              <input type="hidden" name="_subject" value="Nouvelle Confirmation RSVP - Mariage Hatem & Nourhene" />
              <input type="hidden" name="_next" value="https://www.nourehatem.com/#rsvp" />
              <input type="hidden" name="_template" value="table" />
              <input type="hidden" name="_captcha" value="false" />
              <input type="text" name="_honey" style={{display: 'none'}} />
              
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="firstName">{t('rsvp.form.firstName')}</label>
                  <input
                    type="text"
                    id="firstName"
                    name="Prénom"
                    value={formData.firstName}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="lastName">{t('rsvp.form.lastName')}</label>
                  <input
                    type="text"
                    id="lastName"
                    name="Nom"
                    value={formData.lastName}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="attendance">{t('rsvp.form.attendance')}</label>
                <select
                  id="attendance"
                  name="Présence"
                  value={formData.attendance}
                  onChange={handleChange}
                  required
                >
                  <option value="yes">{t('rsvp.form.attendanceYes')}</option>
                  <option value="no">{t('rsvp.form.attendanceNo')}</option>
                </select>
              </div>

              {formData.attendance === 'yes' && (
                <>
                  <div className="form-group">
                    <label htmlFor="numberOfGuests">{t('rsvp.form.guestCount')}</label>
                    <select
                      id="numberOfGuests"
                      name="Nombre_de_personnes"
                      value={formData.numberOfGuests}
                      onChange={handleChange}
                      required
                    >
                      {[1, 2, 3, 4, 5, 6].map(num => (
                        <option key={num} value={num}>{num}</option>
                      ))}
                    </select>
                  </div>

                  <div className="guest-names-section">
                    <label>{t('rsvp.form.guestNames')}</label>
                    {formData.guestNames.map((name, index) => (
                      <div key={index} className="form-group">
                        <input
                          type="text"
                          name={`Personne_${index + 1}`}
                          value={name}
                          onChange={(e) => handleGuestNameChange(index, e.target.value)}
                          placeholder={`${t('rsvp.form.guestNames')} ${index + 1}`}
                          required
                        />
                      </div>
                    ))}
                  </div>
                </>
              )}

              <div className="form-group">
                <label htmlFor="message">{t('rsvp.form.message')}</label>
                <textarea
                  id="message"
                  name="Message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="4"
                  placeholder={t('rsvp.form.messagePlaceholder')}
                ></textarea>
              </div>

              <button type="submit" className="submit-button">
                <Send size={20} />
                {t('rsvp.form.submit')}
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
};

export default RSVPForm;
